export const ZERO_TIMEOBJECT = Object.freeze({
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0,
})

export const ONE_MINUTE_BEFORE_MIDNIGHT_TIMEOBJECT = Object.freeze({
  hour: 23,
  minute: 59,
  second: 0,
  millisecond: 0,
})

export const timeTypes = Object.freeze({
  FROM_TO: 'fromDateTime_toDateTime',
  H_MIN: 'h:mm',
})

export const TIMESTRING_NULL_VALUE = '00:00'
